import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from '../network/data.service';
import { RegisterHelpLinkDto }  from './register-help-link-dto';

@Injectable()
export class HelpLinkService {
    private registeredLinks : string[] = [];
    private linksToSend : RegisterHelpLinkDto[] = [];
    private helpLinksAutoDiscoverEnabled: boolean = true;

    constructor(private dataService: DataService, private router: Router) {
        this.postLinksToServer = this.debounce(() => this.postLinksToServerInternal());
        let self = this;
        this.dataService.get<boolean>('help/isHelpLinksAutoDiscoverEnabled').then(res => {
            self.helpLinksAutoDiscoverEnabled = res;
            self.postLinksToServer();
        });
    }

    public registerLink(id: number) {
        let url = this.router.url.split('?')[0];
        let str = `${id}_${url}`;
        if (this.registeredLinks.indexOf(str) >= 0) {
            return;
        }
        this.registeredLinks.push(str);
        this.linksToSend.push({
            id: id,
            url: url,
        });

        this.postLinksToServer();
    }

    postLinksToServer: () => void;
    private postLinksToServerInternal(): void {
        if (!this.helpLinksAutoDiscoverEnabled || !this.linksToSend || !this.linksToSend.length) {
            return;
        }
        let items = this.linksToSend;
        this.linksToSend = [];
        this.dataService.post<any>('help/registerLinks', {
            items: items,
        });
    }

    private debounce(func: () => void, wait = 2000) {
        let h: any;
        return () => {
            clearTimeout(h);
            h = setTimeout(() => func(), wait);
        };
    }
}